import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "about" */ '../pages/home.vue')
  },
  {
    path: '/pageDefault/:pageId',
    name: 'pageDefault',
    component: () => import(/* webpackChunkName: "about" */ '../pages/pageDefault.vue')
  },
  {
    path: '/pagePesquisaTituloProtesto',
    name: 'pagePesquisaTituloProtesto',
    component: () => import(/* webpackChunkName: "about" */ '../pages/protesto/pagePesquisaTituloProtesto.vue')
  },
  {
    path: '/pageRemessaTituloProtesto',
    name: 'pageRemessaTituloProtesto',
    component: () => import(/* webpackChunkName: "about" */ '../pages/protesto/pageRemessaTituloProtesto.vue')
  },
  {
    path: '/pagePedidoCertidaoProtesto',
    name: 'pagePedidoCertidaoProtesto',
    component: () => import(/* webpackChunkName: "about" */ '../pages/protesto/pagePedidoCertidaoProtesto.vue')
  },
  {
    path: '/pageLgpd',
    name: 'pageLgpd',
    component: () => import(/* webpackChunkName: "about" */ '../pages/lgpd/lgpd.vue')
  },
  {
    path: '/pageEncarregadoFormulario',
    name: 'pageEncarregadoFormulario',
    component: () => import(/* webpackChunkName: "about" */ '../pages/lgpd/encarregadoFormulario.vue')
  },
  {
    path: '/pageOuvidoria',
    name: 'pageOuvidoria',
    component: () => import(/* webpackChunkName: "about" */ '../pages/ouvidoria.vue')
  },
  {
    path: '/pageTrabalheConosco',
    name: 'pageTrabalheConosco',
    component: () => import(/* webpackChunkName: "about" */ '../pages/trabalheConosco.vue')
  },
  {
    path: '/pagePesquisaSatisfacao',
    name: 'pagePesquisaSatisfacao',
    component: () => import(/* webpackChunkName: "about" */ '../pages/pesquisaSatisfacao.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
